module.exports = __webpack_public_path__ + "static/ecad-logo-109420966a78c94dbb2e9e8004d92601.png";